(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('[data-announcement-message]'));
      this.currentIndex = 0;
      this.fadeDuration = 300;
      this.rotationEnabled = this.dataset.rotationEnabled === 'true';
      this.interval = Number(this.dataset.intervalSeconds);

      if (!this.interval || this.interval < 1) {
        this.interval = 5;
      }

      this.showMessage(0);

      if (!this.rotationEnabled || this.messages.length < 2) {
        return;
      }

      this.timer = window.setInterval(() => {
        this.rotate();
      }, this.interval * 1000);
    }

    disconnectedCallback() {
      if (this.timer) {
        window.clearInterval(this.timer);
      }
    }

    rotate() {
      const nextIndex = (this.currentIndex + 1) % this.messages.length;
      const currentMessage = this.messages[this.currentIndex];
      const nextMessage = this.messages[nextIndex];

      currentMessage.classList.remove('is-active');

      window.setTimeout(() => {
        currentMessage.hidden = true;
        nextMessage.hidden = false;

        window.requestAnimationFrame(() => {
          nextMessage.classList.add('is-active');
          this.currentIndex = nextIndex;
        });
      }, this.fadeDuration);
    }

    showMessage(index) {
      this.messages.forEach((message, messageIndex) => {
        const isActive = messageIndex === index;
        message.hidden = !isActive;
        message.classList.toggle('is-active', isActive);
      });
    }
  }

  if (!customElements.get('announcement-rotator')) {
    customElements.define('announcement-rotator', AnnouncementRotator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalogue"]) return;
  try {
    
  if (!customElements.get('catalogue-filter-drawer')) {
    customElements.define(
      'catalogue-filter-drawer',
      class CatalogueFilterDrawer extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('[data-catalogue-filter-dialog]');
          this.openButton = this.querySelector('[data-catalogue-filter-open]');
          this.closeButtons = this.querySelectorAll('[data-catalogue-filter-close]');
          this.openButton?.addEventListener('click', this.open);
          this.closeButtons.forEach((button) => button.addEventListener('click', this.close));
          this.dialog?.addEventListener('click', this.closeFromBackdrop);
        }

        disconnectedCallback() {
          this.openButton?.removeEventListener('click', this.open);
          this.closeButtons.forEach((button) => button.removeEventListener('click', this.close));
          this.dialog?.removeEventListener('click', this.closeFromBackdrop);
        }

        open = () => {
          this.dialog?.showModal();
        };

        close = () => {
          this.dialog?.close();
          this.openButton?.focus();
        };

        closeFromBackdrop = (event) => {
          if (event.target === this.dialog) this.close();
        };
      }
    );
  }

  if (!window.catalogueAjaxFilteringInitialized) {
    window.catalogueAjaxFilteringInitialized = true;

    const renderCatalogue = async (targetUrl, updateHistory = true, reopenDrawer = false) => {
      const currentCatalogue = document.querySelector('[data-catalogue-section]');
      if (!currentCatalogue) return;

      window.catalogueFilterController?.abort();
      window.catalogueFilterController = new AbortController();
      currentCatalogue.setAttribute('aria-busy', 'true');
      currentCatalogue.classList.add('catalogue--loading');

      const browserUrl = new URL(targetUrl, window.location.origin);
      const sectionUrl = new URL(browserUrl);
      sectionUrl.searchParams.set('section_id', currentCatalogue.dataset.sectionId);

      try {
        const response = await fetch(sectionUrl.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: window.catalogueFilterController.signal,
        });
        if (!response.ok) throw new Error('Unable to update the catalogue.');

        const html = await response.text();
        const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
        const updatedCatalogue = parsedDocument.querySelector('[data-catalogue-section]');
        if (!updatedCatalogue) throw new Error('Catalogue section was not returned.');

        currentCatalogue.replaceWith(updatedCatalogue);
        if (updateHistory) window.history.pushState({}, '', browserUrl.toString());

        if (reopenDrawer) {
          updatedCatalogue.querySelector('[data-catalogue-filter-dialog]')?.showModal();
        } else {
          updatedCatalogue.querySelector('.catalogue-filter-pill--active')?.focus({ preventScroll: true });
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        window.location.assign(browserUrl.toString());
      }
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-catalogue-filter-link], .catalogue__pagination a');
      if (!link || !link.closest('[data-catalogue-section]')) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      renderCatalogue(link.href, true, Boolean(link.closest('dialog[open]')));
    });

    window.addEventListener('popstate', () => {
      renderCatalogue(window.location.href, false, false);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-media-gallery')) {
    customElements.define(
      'product-media-gallery',
      class ProductMediaGallery extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.handleThumbnailClick);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleThumbnailClick);
        }

        selectMedia(mediaId) {
          const media = this.querySelector(`[data-product-media="${mediaId}"]`);

          if (!media) return;

          this.querySelectorAll('[data-product-media]').forEach((item) => {
            item.hidden = item !== media;
          });

          this.querySelectorAll('[data-media-thumbnail]').forEach((button) => {
            button.setAttribute('aria-current', String(button.dataset.mediaThumbnail === String(mediaId)));
          });
        }

        handleThumbnailClick = (event) => {
          const thumbnail = event.target.closest('[data-media-thumbnail]');

          if (!thumbnail || !this.contains(thumbnail)) return;

          this.selectMedia(thumbnail.dataset.mediaThumbnail);
        };
      }
    );
  }

  if (!customElements.get('quantity-selector')) {
    customElements.define(
      'quantity-selector',
      class QuantitySelector extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input[type="number"]');
          this.minusButton = this.querySelector('[data-quantity-minus]');
          this.plusButton = this.querySelector('[data-quantity-plus]');
          this.addEventListener('click', this.handleClick);
          this.input?.addEventListener('input', this.updateButtonStates);
          this.updateButtonStates();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          this.input?.removeEventListener('input', this.updateButtonStates);
        }

        handleClick = (event) => {
          const button = event.target.closest('button');

          if (!button || !this.contains(button) || !this.input) return;

          if (button.hasAttribute('data-quantity-minus')) {
            this.input.stepDown();
          } else if (button.hasAttribute('data-quantity-plus')) {
            this.input.stepUp();
          }

          this.input.dispatchEvent(new Event('change', { bubbles: true }));
          this.updateButtonStates();
        };

        updateButtonStates = () => {
          if (!this.input) return;

          const value = Number(this.input.value || 0);
          const minimum = Number(this.input.min || 1);
          const maximum = this.input.max ? Number(this.input.max) : Infinity;
          this.minusButton.disabled = value <= minimum;
          this.plusButton.disabled = value >= maximum;
        };
      }
    );
  }

  if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.submitButton = this.form?.querySelector('[name="add"]');
          this.form?.addEventListener('submit', this.handleSubmit);
        }

        disconnectedCallback() {
          this.form?.removeEventListener('submit', this.handleSubmit);
        }

        handleSubmit = async (event) => {
          event.preventDefault();

          if (!this.form || !this.submitButton || this.submitButton.disabled) return;

          const originalLabel = this.submitButton.textContent;
          this.submitButton.disabled = true;
          this.submitButton.textContent = 'Adding…';

          try {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: new FormData(this.form),
            });

            const item = await response.json();

            if (!response.ok) throw new Error(item.description || 'Unable to add this item.');

            const cart = await this.getCart();
            this.submitButton.textContent = 'Added to cart';
            this.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { item, cart, source: this.submitButton } }));
          } catch (error) {
            this.submitButton.textContent = error.message || 'Try again';
          }

          window.setTimeout(() => {
            this.submitButton.disabled = false;
            this.submitButton.textContent = originalLabel;
          }, 1800);
        };

        async getCart() {
          const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) throw new Error('Unable to refresh your cart.');
          return response.json();
        }
      }
    );
  }

  if (!customElements.get('product-variant-picker')) {
    customElements.define(
      'product-variant-picker',
      class ProductVariantPicker extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-variant-data]').textContent);
          this.variantInput = this.querySelector('[data-variant-id]');
          this.form = this.closest('form');
          this.section = this.closest('.main-product');
          this.addEventListener('change', this.handleChange);

          const currentVariant = this.variants.find((variant) => String(variant.id) === this.variantInput.value);

          if (currentVariant) this.updateState(currentVariant, false);
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.handleChange);
        }

        get selectedOptions() {
          return [...this.querySelectorAll('.main-product__option-group')].map((group) => {
            return group.querySelector('.main-product__option-input:checked')?.value;
          });
        }

        handleChange = (event) => {
          const input = event.target.closest('.main-product__option-input');

          if (!input) return;

          const selectedOptions = this.selectedOptions;
          let variant = this.findVariant(selectedOptions);

          if (!variant?.available) {
            const changedIndex = Number(input.dataset.optionPosition) - 1;
            variant = this.variants.find((candidate) => {
              return candidate.available && candidate.options[changedIndex] === input.value;
            });

            if (variant) this.selectVariantOptions(variant);
          }

          if (variant) this.updateState(variant, true);
        };

        findVariant(options) {
          return this.variants.find((variant) => {
            return variant.options.every((value, index) => value === options[index]);
          });
        }

        selectVariantOptions(variant) {
          variant.options.forEach((value, index) => {
            const input = [...this.querySelectorAll(`[data-option-position="${index + 1}"]`)].find(
              (candidate) => candidate.value === value
            );

            if (input) input.checked = true;
          });
        }

        updateState(variant, updateUrl) {
          this.variantInput.value = variant.id;
          this.updateAvailability(variant.options);
          this.updatePrice(variant);
          this.updateSubmitButton(variant);
          this.updateMedia(variant);

          if (updateUrl) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);
          }

          this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
        }

        updateAvailability(selectedOptions) {
          this.querySelectorAll('.main-product__option-input').forEach((input) => {
            const optionIndex = Number(input.dataset.optionPosition) - 1;
            const candidateOptions = [...selectedOptions];
            candidateOptions[optionIndex] = input.value;
            const candidate = this.findVariant(candidateOptions);
            input.disabled = !candidate?.available;
          });
        }

        updatePrice(variant) {
          const price = this.section.querySelector('[id^="ProductPrice-"]');

          if (!price) return;

          price.replaceChildren();

          if (variant.compareAtPriceAmount > variant.priceAmount) {
            const salePrice = document.createElement('span');
            const comparePrice = document.createElement('s');
            salePrice.className = 'main-product__sale-price';
            salePrice.textContent = variant.price;
            comparePrice.textContent = variant.compareAtPrice;
            price.append(salePrice, comparePrice);
          } else {
            const regularPrice = document.createElement('span');
            regularPrice.textContent = variant.price;
            price.append(regularPrice);
          }
        }

        updateSubmitButton(variant) {
          const button = this.form.querySelector('[name="add"]');

          if (!button) return;

          button.disabled = !variant.available;
          button.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }

        updateMedia(variant) {
          if (!variant.featuredMediaId) return;

          this.section.querySelector('product-media-gallery')?.selectMedia(variant.featuredMediaId);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meta-catalogue"] && !Shopify.designMode) return;
  try {
    
  if (!window.metaCatalogueAjaxFilteringInitialized) {
    window.metaCatalogueAjaxFilteringInitialized = true;

    const catalogueLevelParams = [
      'filter.p.m.custom.catalogue_level_1',
      'filter.p.m.custom.catalogue_level_2',
      'filter.p.m.custom.catalogue_level_3',
      'filter.p.m.custom.catalogue_level_4',
    ];

    const updateScrollCue = (row) => {
      const cueContainer = row.closest('.meta-catalogue__filter-group, .meta-catalogue__applied, .meta-catalogue__slider');
      if (!cueContainer) return;

      const maximumScroll = Math.max(0, row.scrollWidth - row.clientWidth);
      cueContainer.classList.toggle('meta-catalogue--scrolled-from-start', row.scrollLeft > 2);
      cueContainer.classList.toggle('meta-catalogue--has-more-to-scroll', row.scrollLeft < maximumScroll - 2);
    };

    const initializeScrollCues = (scope = document) => {
      scope.querySelectorAll('.meta-catalogue__filter-values, .meta-catalogue__grid').forEach((row) => {
        updateScrollCue(row);
        if (row.dataset.metaCatalogueScrollCueInitialized) return;

        row.dataset.metaCatalogueScrollCueInitialized = 'true';
        row.addEventListener('scroll', () => updateScrollCue(row), { passive: true });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeScrollCues(), { once: true });
    } else {
      initializeScrollCues();
    }

    window.addEventListener('resize', () => initializeScrollCues());

    const renderMetaCatalogue = async (targetUrl, updateHistory = true, resetPage = false) => {
      const currentCatalogue = document.querySelector('[data-meta-catalogue-section]');
      if (!currentCatalogue) return;

      window.metaCatalogueFilterController?.abort();
      window.metaCatalogueFilterController = new AbortController();
      currentCatalogue.setAttribute('aria-busy', 'true');
      currentCatalogue.classList.add('meta-catalogue--loading');

      const browserUrl = new URL(targetUrl, window.location.origin);
      if (resetPage) browserUrl.searchParams.delete('page');
      const sectionUrl = new URL(browserUrl);
      sectionUrl.searchParams.set('section_id', currentCatalogue.dataset.sectionId);

      try {
        const response = await fetch(sectionUrl.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: window.metaCatalogueFilterController.signal,
        });
        if (!response.ok) throw new Error('Unable to update the catalogue.');

        const html = await response.text();
        const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
        const updatedCatalogue = parsedDocument.querySelector('[data-meta-catalogue-section]');
        if (!updatedCatalogue) throw new Error('Meta catalogue section was not returned.');

        currentCatalogue.replaceWith(updatedCatalogue);
        if (updateHistory) window.history.pushState({}, '', browserUrl.toString());

        initializeScrollCues(updatedCatalogue);
        updatedCatalogue.querySelector('.meta-catalogue__pill--active:last-of-type')?.focus({ preventScroll: true });
      } catch (error) {
        if (error.name === 'AbortError') return;
        window.location.assign(browserUrl.toString());
      }
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-meta-catalogue-filter-link], .meta-catalogue__pagination a');
      if (!link || !link.closest('[data-meta-catalogue-section]')) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      const targetUrl = new URL(link.href, window.location.origin);
      const removeLevel = Number(link.dataset.metaCatalogueRemoveLevel || 0);

      if (removeLevel > 0) {
        catalogueLevelParams.slice(removeLevel - 1).forEach((paramName) => targetUrl.searchParams.delete(paramName));
      }

      const isPaginationLink = Boolean(link.closest('.meta-catalogue__pagination'));
      renderMetaCatalogue(targetUrl.toString(), true, !isPaginationLink);
    });

    window.addEventListener('popstate', () => {
      renderMetaCatalogue(window.location.href, false, false);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
